import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/platform", label: "Platform" },
  { to: "/channels", label: "Channels" },
  { to: "/audience-data", label: "Audience & Data" },
  { to: "/why-responsiq", label: "Why RresponsIQ" },
  { to: "/pricing", label: "Pricing" },
  { to: "/company", label: "Company" },
];

export const Logo = () => (
  <Link to="/" className="flex items-center" data-testid="brand-logo" aria-label="RresponsIQ home — a Xyle company">
    <img src="/assets/logo.webp" alt="RresponsIQ" className="h-7 w-auto" />
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-50 bg-[#101820] border-b border-[#F7F9FA]/10" data-testid="site-header">
      <div className="container-riq flex items-center justify-between h-16">
        <Logo />
        <nav className="hidden lg:flex items-center gap-6" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `font-nav text-xs uppercase tracking-widest font-bold transition-colors hover:text-white ${isActive ? "text-[#32A2C5]" : "text-[#F7F9FA]/70"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/book-demo" data-testid="nav-book-demo-btn" className="btn-primary !px-4 !py-2.5 !text-xs">
            Book a Demo
          </Link>
          <button
            className="lg:hidden p-2 rounded-lg border border-[#F7F9FA]/20 text-[#F7F9FA]"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-[#F7F9FA]/10 bg-[#101820]" aria-label="Mobile" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `block px-6 py-4 border-b border-[#F7F9FA]/10 font-nav text-sm uppercase tracking-widest font-bold ${isActive ? "text-[#32A2C5]" : "text-[#F7F9FA]/80"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
